export default theme => ({
  eventStatusWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    marginBottom: '2px',
    marginTop: '2px',
  },
  eventText: {
    fontSize: '0.75rem',
    fontWeight: '500',
    padding: '2px 11px',
    border: '1px solid',
    borderRadius: '11px',
    backgroundColor: 'white',
  },
  pendingVerificationImgWrapper: {
    borderColor: '#3E82FF',
    color: '#3E82FF',
  },
  verifiedImgWrapper: {
    borderColor: '#0C842B',
    color: '#0C842B',
  },
  createdVerificationImgWrapper: {
    borderColor: '#D14646',
    color: '#D14646',
  },
  publishedImgWrapper: {
    borderColor: '#979797',
    color: '#425A70',
  },
  unpublishedImgWrapper: {
    borderColor: '#D14646',
    color: '#D14646',
  },
  removeDwlVerificationWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  removeDwlVerification: {
    padding: 0,
    color: '#dd6060',
    display: 'inline-flex'
  },
  metaBlock: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'space-between',
    marginTop: '14px',
  },
  verifyButtonHolder: {
    float: 'right',
  },
  sheetLocation: {
    fontSize: '0.85rem',
    display: 'flex',
    color: '#3E82FF',
    alignItems: 'center',
    marginBottom: '8px'
  },
  locationIcon: {
    width: '14px',
    marginRight: '4px',
    filter: 'invert(40%) sepia(72%) saturate(1866%) hue-rotate(205deg) brightness(101%) contrast(104%)'
  }
})